var render = function render(_c,_vm){return _c('input',{staticClass:"range-slider",style:({width : _vm.props.width, margin: _vm.props.margin}),attrs:{"type":"range"},domProps:{"value":_vm.props.value},on:{"input":function($event){return _vm.listeners['input']($event.target.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }